import { AUTH_FAILED, ERROR_CODE_MAP, INVALID_ALLOCATION, INVALID_CUSTOM_SECURITY, INVALID_CUSTOM_SECURITY_LEVELS, INVALID_RESPONSE, MISSING_IDS, NO_HOLDINGS, NO_SEARCH_RESULTS, REFRESH_INVALID_API_LEVELS, REFRESH_INVALID_ENTITY_ID, ZERO_ACCOUNT_VALUE, } from 'IntegrationsApp/ts/constants';
import * as i0 from "@angular/core";
export class IntegrationErrorHandlingService {
    handleSearchErrorResponse(res) {
        switch (res.status) {
            case 401:
                if (res.error?.errorMessage) {
                    return res.error.errorMessage;
                }
                return ERROR_CODE_MAP.AUTH_FAILED;
            case 500:
                if (res.error?.errorMessage) {
                    return res.error.errorMessage;
                }
                return ERROR_CODE_MAP.INVALID_RESPONSE;
            default:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
        }
    }
    handleImportHoldingsErrorResponse(res) {
        switch (res.error.errorCode) {
            case MISSING_IDS:
                return ERROR_CODE_MAP.MISSING_IDS;
            case AUTH_FAILED:
                return ERROR_CODE_MAP.AUTH_FAILED;
            case NO_HOLDINGS:
                return ERROR_CODE_MAP.NO_HOLDINGS;
            case NO_SEARCH_RESULTS:
                return ERROR_CODE_MAP.NO_SEARCH_RESULTS;
            case ZERO_ACCOUNT_VALUE:
                return ERROR_CODE_MAP.ZERO_ACCOUNT_VALUE;
            case INVALID_ALLOCATION:
                // The backend sends a specific reason (sum != 100%, no allocation data, mixed
                // selection); show it, falling back to the generic message if it's missing.
                return res.error?.errorMessage || ERROR_CODE_MAP.INVALID_ALLOCATION;
            case INVALID_RESPONSE:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
            default:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
        }
    }
    handleRefreshHoldingsErrorResponse(res) {
        switch (res.status) {
            case 401:
                return ERROR_CODE_MAP.AUTH_FAILED;
            case 404:
                return ERROR_CODE_MAP.REMOVED_ACCOUNTS;
            case 500:
                if (res.error?.errorMessage) {
                    return res.error.errorMessage;
                }
                return ERROR_CODE_MAP.INVALID_RESPONSE;
            case 400:
                // The backend sends the specific allocation error message (sum != 100%, no allocation
                // data, mixed selection); surface it directly, falling back to the generic message.
                // During a rolling deploy/rollback an older backend may still emit the raw
                // INVALID_ALLOCATION code as the message, so map that back to the human-readable string.
                if (res.error?.errorMessage) {
                    if (res.error.errorMessage === INVALID_ALLOCATION) {
                        return ERROR_CODE_MAP.INVALID_ALLOCATION;
                    }
                    return res.error.errorMessage;
                }
                return ERROR_CODE_MAP.INVALID_RESPONSE;
            default:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
        }
    }
    handleImportCustomSecurityErrorResponse(res) {
        switch (res.error.errorCode) {
            case MISSING_IDS:
                return ERROR_CODE_MAP.MISSING_IDS;
            case AUTH_FAILED:
                return ERROR_CODE_MAP.AUTH_FAILED;
            case NO_HOLDINGS:
                return ERROR_CODE_MAP.NO_HOLDINGS;
            case INVALID_RESPONSE:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
            case INVALID_CUSTOM_SECURITY:
                return ERROR_CODE_MAP.INVALID_CUSTOM_SECURITY;
            case INVALID_CUSTOM_SECURITY_LEVELS:
                return ERROR_CODE_MAP.INVALID_CUSTOM_SECURITY_LEVELS;
            default:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
        }
    }
    handleRefreshImportCustomSecurityErrorResponse(res) {
        switch (res.error.errorCode) {
            case AUTH_FAILED:
                return ERROR_CODE_MAP.AUTH_FAILED;
            case INVALID_RESPONSE:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
            case INVALID_CUSTOM_SECURITY:
                return ERROR_CODE_MAP.INVALID_CUSTOM_SECURITY;
            case INVALID_CUSTOM_SECURITY_LEVELS:
                return ERROR_CODE_MAP.INVALID_CUSTOM_SECURITY_LEVELS;
            case REFRESH_INVALID_API_LEVELS:
                return ERROR_CODE_MAP.REFRESH_INVALID_API_LEVELS;
            case REFRESH_INVALID_ENTITY_ID:
                return ERROR_CODE_MAP.REFRESH_INVALID_ENTITY_ID;
            default:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
        }
    }
}
IntegrationErrorHandlingService.ɵfac = function IntegrationErrorHandlingService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IntegrationErrorHandlingService)(); };
IntegrationErrorHandlingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IntegrationErrorHandlingService, factory: IntegrationErrorHandlingService.ɵfac, providedIn: 'root' });
export class PershingIntegrationErrorHandlingService extends IntegrationErrorHandlingService {
    handleSearchErrorResponse(res) {
        switch (res.status) {
            case 401:
                return ERROR_CODE_MAP.AUTH_FAILED;
            case 409:
                return ERROR_CODE_MAP.TOO_MANY_RESULTS;
            case 500:
                if (res.error?.errorMessage) {
                    return res.error.errorMessage;
                }
                return ERROR_CODE_MAP.INVALID_RESPONSE;
            default:
                return ERROR_CODE_MAP.INVALID_RESPONSE;
        }
    }
}
PershingIntegrationErrorHandlingService.ɵfac = /*@__PURE__*/ (() => { let ɵPershingIntegrationErrorHandlingService_BaseFactory; return function PershingIntegrationErrorHandlingService_Factory(__ngFactoryType__) { return (ɵPershingIntegrationErrorHandlingService_BaseFactory || (ɵPershingIntegrationErrorHandlingService_BaseFactory = i0.ɵɵgetInheritedFactory(PershingIntegrationErrorHandlingService)))(__ngFactoryType__ || PershingIntegrationErrorHandlingService); }; })();
PershingIntegrationErrorHandlingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PershingIntegrationErrorHandlingService, factory: PershingIntegrationErrorHandlingService.ɵfac, providedIn: 'root' });
